import React from "react";

export const Eyebrow = ({ children, className = "" }) => (
    <span
        className={`ns-eyebrow ${className}`}
        data-testid="page-eyebrow"
    >
        {children}
    </span>
);

export const PageHero = ({ eyebrow, title, lead, children }) => (
    <section className="ns-cross-pattern border-b border-[var(--ns-border)]">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-10 py-24 lg:py-32">
            <div className="max-w-3xl">
                {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
                <h1
                    className="font-display mt-6 text-4xl sm:text-5xl lg:text-[64px] font-bold leading-[1.05] tracking-tight"
                    style={{ color: "var(--ns-ink)" }}
                    data-testid="page-title"
                >
                    {title}
                </h1>
                {lead && (
                    <p
                        className="font-body mt-8 text-lg leading-relaxed max-w-2xl"
                        style={{ color: "var(--ns-body)" }}
                    >
                        {lead}
                    </p>
                )}
                {children}
            </div>
        </div>
    </section>
);

export const Section = ({ children, className = "", id }) => (
    <section id={id} className={className}>
        <div className="max-w-[1280px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
            {children}
        </div>
    </section>
);

export const Breadcrumb = ({ items }) => (
    <nav className="mb-6" aria-label="Breadcrumb">
        <ol className="flex items-center gap-2 text-sm">
            {items.map((it, i) => (
                <li key={i} className="flex items-center gap-2">
                    {i > 0 && (
                        <span style={{ color: "var(--ns-muted-2)" }}>/</span>
                    )}
                    {it.to ? (
                        <a
                            href={it.to}
                            className="font-body hover:underline"
                            style={{ color: "var(--ns-muted)" }}
                        >
                            {it.label}
                        </a>
                    ) : (
                        <span
                            className="font-body"
                            style={{ color: "var(--ns-ink)" }}
                        >
                            {it.label}
                        </span>
                    )}
                </li>
            ))}
        </ol>
    </nav>
);
